import React from 'react';
import { DetailCardType } from 'types/DetailPageTypes';
import { TabType } from 'types/TabTypes';
import DetailPage from 'components/layout/DetailPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { HeaderButtons } from 'types/ButtonTypes';

// Rename the name of the function:
const EmailLayoutPage: React.FC = () => {

    // Specify the parameters of this detail page:
    const apiObject = 'email_layout';
    const pageObject = 'email_layout';
    const headerTitle = 'email.email_layout.customize_email_layout_title';
    const backButtonUrl = '/settings/features/email/email-layouts';

    // Define the header buttons:
    const headerButtons: HeaderButtons = [
        {   
            type: 'icon',
            icon: <FontAwesomeIcon icon={faTrash} />,
            size: 'medium',
            tooltipText: 'general.delete',
            action: 'delete',
            onSuccess: 'redirect',
            redirectTo: 'settings/features/email/email-layouts',
        },
    ]

    // Define the detail page tabs:
    const LayoutExample: TabType[] = [{ type: 'email-layout' }]

    // Set the default email layout field cards
    const fieldCards: DetailCardType[] = [
        {
            component: 'FieldsCard',
            title: 'email.email_layout.general_title',
            alignment: 'horizontal',
            fields: [
                {
                    name: 'name',
                    label: 'email.email_layout.layout_name_label',
                    type: 'text',
                    placeholder: 'email.email_layout.layout_name_placeholder',
                },
                {
                    name: 'division',
                    label: 'email.email_domain.division_label',
                    type: 'dropdown',
                    disabled_selected: 'email.email_domain.select_division_disabled_selected',
                    showSearch: false,
                    apiRequest: [{
                        endpoint: 'get_division_list',
                        object: 'division',
                        params: { is_active: true },
                        useCache: true
                    }],
                    allowNoneOption: true,
                    activeFeature: 'divisions'
                },
                {
                    name: 'is_default',
                    label: 'email.email_layout.default_layout_label',
                    type: 'switch',
                    onValue: 'forms.true_value',
                    offValue: 'forms.false_value',
                    tooltipText: 'email.email_layout.default_layout_tooltipText'
                },
            ],
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.layout_style_title',
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'dropdown', 
                    name: 'style', 
                    label: 'email.email_layout.style_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    hardcodedOptions: [
                        { name: 'email.email_layout.style.basic', value: 'basic' },
                        { name: 'email.email_layout.style.professional', value: 'professional' },
                    ],
                    allowNoneOption: false,
                    showSearch: false,
                },
            ],
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.background_title',
            dataCondition: [{'style': 'professional'}],
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'text', 
                    name: 'background_color', 
                    label: 'email.email_layout.background_color_label',
                    placeholder: 'email.email_layout.color_placeholder',
                },
                { 
                    type: 'text', 
                    name: 'section_background_color', 
                    label: 'email.email_layout.section_background_color_label',
                    placeholder: 'email.email_layout.color_placeholder',
                },
            ],
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.header_title',
            dataCondition: [{'style': 'professional'}],
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'switch', 
                    name: 'show_header', 
                    label: 'email.email_layout.show_header_label'
                },
                { 
                    type: 'text', 
                    name: 'header_background_color', 
                    label: 'email.email_layout.header_background_color_label',
                    placeholder: 'email.email_layout.color_placeholder',
                    dataCondition: [{'show_header': true}],
                },
            ],
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.logo_title',
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'switch', 
                    name: 'show_logo', 
                    label: 'email.email_layout.show_logo_label'
                },
                { 
                    type: 'dropdown', 
                    name: 'logo_placement', 
                    label: 'email.email_layout.placement_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { name: 'email.email_layout.placement.top', value: 'top'},
                        { name: 'email.email_layout.placement.bottom', value: 'bottom'},
                    ],
                    dataCondition: [
                        {'show_logo': true},
                        {'style': 'professional'}
                    ],
                },
                { 
                    type: 'dropdown', 
                    name: 'logo_position', 
                    label: 'email.email_layout.position_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { name: 'email.email_layout.position.left', value: 'left'},
                        { name: 'email.email_layout.position.center', value: 'center'},
                        { name: 'email.email_layout.position.right', value: 'right'},
                    ],
                    dataCondition: [
                        {'show_logo': true},
                        {'style': 'professional'}
                    ],
                },
                { 
                    type: 'switch', 
                    name: 'use_custom_logo', 
                    label: 'email.email_layout.use_custom_logo_label',
                    tooltipText: 'email.email_layout.use_custom_logo_tooltipText',
                    dataCondition: [
                        {'show_logo': true},
                    ],
                },
                { 
                    type: 'image', 
                    name: 'custom_logo', 
                    label: 'email.email_layout.upload_custom_logo_label', 
                    imageType: 'logo-rectangle',
                    dropzoneText: 'email.email_layout.custom_logo_placeholder',
                    apiField: { 
                        fileUpload: 'custom_logo_file', 
                        fileName: 'custom_logo_filename',
                        imageDeleted: 'custom_logo_deleted'
                    },
                    dataCondition: [
                        {'show_logo': true},
                        {'use_custom_logo': true}
                    ],
                },
            ],
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.title_title',
            alignment: 'horizontal',
            dataCondition: [{'style': 'professional'}],
            fields: [
                { 
                    type: 'switch', 
                    name: 'show_title', 
                    label: 'email.email_layout.show_title_label',
                    tooltipText: 'email.email_layout.show_title_tooltipText',
                },
            ]
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.text_settings_title',
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'dropdown', 
                    name: 'font_family', 
                    label: 'email.email_layout.font_family_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: 'arial', name: 'Arial'},
                        { value: 'helvetica', name: 'Helvetica'},
                        { value: 'times_new_roman', name: 'Times New Roman'},
                        { value: 'verdana', name: 'Verdana'},
                        { value: 'georgia', name: 'Georgia'},
                        { value: 'tahoma', name: 'Tahoma'},
                    ],
                },
                {
                    type: 'dropdown',
                    name: 'line_height',
                    label: 'email.email_layout.line_height_label',
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { name: 'email.email_layout.line_height.compact', value: 'compact'},
                        { name: 'email.email_layout.line_height.normal', value: 'normal'},
                        { name: 'email.email_layout.line_height.roomy', value: 'roomy'},
                        { name: 'email.email_layout.line_height.spacious', value: 'spacious'},
                    ],
                },
                {
                    type: 'dropdown',
                    name: 'paragraph_spacing',
                    label: 'email.email_layout.paragraph_spacing_label',
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { name: '1.0', value: '1.0'},
                        { name: '1.5', value: '1.5'},
                        { name: '2.0', value: '2.0'},
                    ],
                },
                { 
                    type: 'text', 
                    name: 'font_color', 
                    label: 'email.email_layout.font_color_label',
                    placeholder: 'email.email_layout.color_placeholder',
                    dataCondition: [{'style': 'professional'}],
                },
            ],
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.button_settings_title',
            dataCondition: [{'style': 'professional'}],
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'text', 
                    name: 'button_color', 
                    label: 'email.email_layout.button_color_label',
                    placeholder: 'email.email_layout.color_placeholder',
                    dataCondition: [{'style': 'professional'}],
                },
                { 
                    type: 'text', 
                    name: 'button_font_color', 
                    label: 'email.email_layout.button_font_color_label',
                    placeholder: 'email.email_layout.color_placeholder',
                    dataCondition: [{'style': 'professional'}],
                },
                { 
                    type: 'dropdown', 
                    name: 'button_size', 
                    label: 'email.email_layout.button_size_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: 'small', name: 'email.email_layout.button_size.small'},
                        { value: 'medium', name: 'email.email_layout.button_size.medium'},
                        { value: 'large', name: 'email.email_layout.button_size.large'},
                    ],
                    dataCondition: [{'style': 'professional'}],
                },
                { 
                    type: 'dropdown', 
                    name: 'button_radius', 
                    label: 'email.email_layout.button_radius_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: '2', name: '2px'},
                        { value: '4', name: '4px'},
                        { value: '6', name: '6px'},
                        { value: '8', name: '8px'},
                    ],
                    dataCondition: [{'style': 'professional'}],
                },
                { 
                    type: 'dropdown', 
                    name: 'button_position', 
                    label: 'email.email_layout.button_position_label', 
                    disabled_selected: 'forms.select_type_disabled_selected',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: 'left', name: 'email.email_layout.position.left'},
                        { value: 'center', name: 'email.email_layout.position.center'},
                    ],
                    dataCondition: [{'style': 'professional'}],
                },
            ]
        },
        {
            component: 'FieldsCard',
            title: 'email.email_layout.footer_settings_title',
            dataCondition: [{'style': 'professional'}],
            alignment: 'horizontal',
            fields: [
                { 
                    type: 'switch', 
                    name: 'show_footer', 
                    label: 'email.email_layout.show_footer_label',
                    dataCondition: [{'style': 'professional'}],
                },
                { 
                    type: 'text', 
                    name: 'footer_background_color', 
                    label: 'email.email_layout.footer_background_color',
                    placeholder: 'email.email_layout.color_placeholder',
                    dataCondition: [
                        {'style': 'professional'},
                        {'show_footer': true}
                    ],
                },
            ]
        }
    ];

    return (
        <DetailPage
            apiObject={apiObject}
            pageObject={pageObject}
            headerTitle={headerTitle}
            headerButtons={headerButtons}
            detailCards={fieldCards}
            tabs={LayoutExample}
            backButtonUrl={backButtonUrl}
        />
    );
};

export default EmailLayoutPage;